import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Logo from '@/components/Logo';
import TwoTone from '@/components/TwoTone';
import TimeFormat from '@/components/TimeFormat';

const useStyles = makeStyles(() => ({
  player: {
    fontWeight: 'bold',
  },
  container: {
    padding: 10,
  },
}))

function PenaltyInfo({ penalty, players, teams }) {
  const classes = useStyles();

  // Gets the player name from the ID
  function getPlayerName(id){
    return players[id].name;
  }

  // Gets the player team from the ID
  function getPlayerTeam(id){
    const team = players[id].team;
    return teams[team].id;
  }

  return (
    <Grid container className={classes.container}>
      <Grid container alignItems="center" item xs={12} spacing={1}>
        <Grid item xs={3}>
          <Logo size={5} id={getPlayerTeam(penalty.player)} />
        </Grid>
        <Grid container item xs>
          <Grid item xs={12}>
            <Typography className={classes.player}>{getPlayerName(penalty.player)}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="caption">
              {penalty.description}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <TwoTone
          renderLeft={
            <Typography variant="caption">
              <TimeFormat time={penalty.second} /> / {penalty.period}
            </Typography>
          }
          renderRight={
            <Typography variant="caption">
              {penalty.type} - {penalty.penalty}
            </Typography>
          }
        />
      </Grid>
    </Grid>
  )
}

export default PenaltyInfo;
